"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NETWORK_STATUS_LABELS = exports.NETWORK_STATUS_STYLES = exports.NETWORK_STATUS_RANK = exports.NETWORK_THRESHOLDS = void 0;
exports.rateUpperThreshold = rateUpperThreshold;
exports.rateLowerThreshold = rateLowerThreshold;
exports.worstNetworkStatus = worstNetworkStatus;
exports.computeMetricsStatus = computeMetricsStatus;
// Thresholds calibrated for a fiber / 5G fleet: they flag deviation from the
// expected infrastructure, not just functional failure.
exports.NETWORK_THRESHOLDS = {
    latencyMs: { degraded: 100, critical: 200 },
    jitterMs: { degraded: 50, critical: 90 },
    lossPercent: { degraded: 1, critical: 3 },
    downloadMbps: { degraded: 25, critical: 5 }, // below threshold → degraded/critical
    uploadMbps: { degraded: 10, critical: 2 },
};
exports.NETWORK_STATUS_RANK = {
    good: 0,
    degraded: 1,
    critical: 2,
};
exports.NETWORK_STATUS_STYLES = {
    good: 'bg-green-500/15 text-green-700 dark:text-green-400',
    degraded: 'bg-amber-500/15 text-amber-700 dark:text-amber-400',
    critical: 'bg-red-500/15 text-red-700 dark:text-red-400',
};
exports.NETWORK_STATUS_LABELS = {
    good: 'Bonne',
    degraded: 'Dégradée',
    critical: 'Critique',
};
function rateUpperThreshold(value, t) {
    if (value == null || Number.isNaN(value))
        return null;
    if (value > t.critical)
        return 'critical';
    if (value > t.degraded)
        return 'degraded';
    return 'good';
}
function rateLowerThreshold(value, t) {
    if (value == null || Number.isNaN(value))
        return null;
    if (value < t.critical)
        return 'critical';
    if (value < t.degraded)
        return 'degraded';
    return 'good';
}
function worstNetworkStatus(...statuses) {
    let worst = 'good';
    for (const s of statuses) {
        if (s && exports.NETWORK_STATUS_RANK[s] > exports.NETWORK_STATUS_RANK[worst]) {
            worst = s;
        }
    }
    return worst;
}
/**
 * Computes the overall network quality status directly from the raw metrics
 * using the shared NETWORK_THRESHOLDS.
 */
function computeMetricsStatus(metrics) {
    if (!metrics)
        return null;
    const { latencyMs, jitterMs, lossPercent, downloadMbps, uploadMbps } = metrics;
    const hasAnyMetric = latencyMs != null ||
        jitterMs != null ||
        lossPercent != null ||
        downloadMbps != null ||
        uploadMbps != null;
    if (!hasAnyMetric)
        return null;
    return worstNetworkStatus(rateUpperThreshold(latencyMs, exports.NETWORK_THRESHOLDS.latencyMs), rateUpperThreshold(jitterMs, exports.NETWORK_THRESHOLDS.jitterMs), rateUpperThreshold(lossPercent, exports.NETWORK_THRESHOLDS.lossPercent), rateLowerThreshold(downloadMbps, exports.NETWORK_THRESHOLDS.downloadMbps), rateLowerThreshold(uploadMbps, exports.NETWORK_THRESHOLDS.uploadMbps));
}
